/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */

import { Checkbox, HoverCard, HoverCardType, Spinner, Text, initializeIcons, Stack } from "@fluentui/react";
import { Accordion, AccordionItem, AccordionHeader, AccordionPanel } from "@fluentui/react-components";
import { Add20Filled, Subtract20Filled } from "@fluentui/react-icons";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { getSiteIdentifier } from "@/helpers/siteIdentifierHelper";
import { getDocumentLink, getDriveItemId, getFileType, getIsRedlined } from "@/helpers/fallback-response-helper";
import { getToken } from "@/helpers/accessTokenHelper";
import FileIconHoverCard from "./FileIconHoverCard";
import LockIcon from "../../Compare/components/Icons/LockIcon";
import EditIcon from "../../Compare/components/Icons/EditIcon";
import ViewDoc from "./Icons(SVG)/ViewDoc";
import EditDoc from "./Icons(SVG)/EditDoc";
import PdfAttachmentViewer from "./PdfAttachmentViewer";
import { launchDocument } from "../utility/launchDocument";
import { ensureDocumentSaved } from "@/taskpane/utility/ensureDocumentSaved";

initializeIcons();
const AccordianItemStyles = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: 600,
  color: "#18468F",
};
function getFormattedDateTime(dateString) {
  const date = new Date(dateString);
  // Format the date
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const formattedDate = `${month}/${day}/${year}`;
  // Format the time
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const formattedTime = `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  return [formattedDate, formattedTime];
}

function getFullName(user) {
  let fullName = `${user?.firstName} ${user?.lastName}`;
  return fullName;
}

export default function Details({ refreshDocument, setRefreshDocument, graphToken }) {
  const [openItems, setOpenItems] = useState([1]);
  const [folderName, setFolderName] = useState("");
  const [rootDocId, setRootDocId] = useState(0);
  const [document, setDocument] = useState();
  const [project, setProject] = useState();
  const [versions, setVersions] = useState([]);
  const [documentLoading, setDocumentLoading] = useState(false);
  const [versionLoading, setVersionLoading] = useState(false);
  const [documentHistoryLoaded, setDocumentHistoryLoaded] = useState(false);
  const [docError, setDocError] = useState(false);

  const handleToggle = useCallback(
    (_, data) => {
      if (openItems.includes(data.value)) {
        setOpenItems(openItems.filter((item) => item !== data.value)); // Close the item
      } else {
        setOpenItems([data.value]); // Open the item
      }
    },
    [openItems]
  );

  useEffect(async () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      setDocumentLoading(true);
      setVersionLoading(true);
      axios
        .get(
          `https://addins.api.dexterity.legal/gateway/api/v1/documents/item?url=${encodeURIComponent(
            context.value.url
          )}&byPass=true`,
          {
            headers: {
              Authorization: `Bearer ${graphToken}`,
              "Site-Identifier": getSiteIdentifier(context.value.url),
              "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
            },
          }
        )
        .then((response) => {
          sessionStorage.setItem("projectId", response.data?.data?.projectId);
          sessionStorage.setItem("rootDocumentId", response.data?.data?.rootDocumentId);
          sessionStorage.setItem("fileType", response.data?.data?.fileType);
          sessionStorage.setItem("url", context.value.url);
          sessionStorage.setItem("fileName", response.data?.data?.driveItemName);
          sessionStorage.setItem("folderName", response.data?.data?.projectName);
          var doc = JSON.stringify(response.data?.data);
          sessionStorage.setItem("document", doc);
          setFolderName(response.data?.data?.projectName);
          setRootDocId(response.data?.data?.rootDocumentId);
          setDocument(response.data?.data);
          setDocumentLoading(false);
        })
        .catch(() => {
          setDocError(true);
          setDocumentLoading(false);
        });
    });
  }, [graphToken, refreshDocument]);

  useEffect(async () => {
    if (folderName && folderName.length) {
      axios
        .get(`https://addins.api.dexterity.legal/gateway/api/v1/projects/${sessionStorage.getItem("projectId")}`, {
          headers: {
            Authorization: `Bearer ${graphToken}`,
            "Site-Identifier": getSiteIdentifier(),
            "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
          },
        })
        .then((response) => {
          setProject(response.data);
        });
    }
  }, [folderName]);

  useEffect(async () => {
    if (folderName && folderName.length) {
      const json = JSON.parse(sessionStorage.getItem("document"));
      axios
        .get(`https://addins.api.dexterity.legal/gateway/api/v1/save/version?driveItemId=${getDriveItemId(json)}`, {
          headers: {
            Authorization: `Bearer ${graphToken}`,
            "Site-Identifier": getSiteIdentifier(),
            "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
          },
        })
        .then((response) => {
          sessionStorage.setItem("versionId", response.data);
        });
    }
  }, [folderName]);

  useEffect(async () => {
    setVersionLoading(true);
    if (rootDocId) {
      axios
        .get(`https://addins.api.dexterity.legal/gateway/api/v1/documents/${rootDocId}/versions`, {
          headers: {
            Authorization: `Bearer ${graphToken}`,
            "Site-Identifier": getSiteIdentifier(),
            "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
          },
        })
        .then((response) => {
          setVersions(response.data?.data?.data);
          setDocumentHistoryLoaded(true);
          setVersionLoading(false);
        })
        .catch(() => {
          setVersionLoading(false);
        });
    }
  }, [rootDocId, refreshDocument]);
  return (
    <div style={{ marginTop: "2vh" }}>
      <Accordion onToggle={handleToggle} openItems={openItems} collapsible defaultOpenItems={[1]}>
        {
          <AccoItem
            openItems={openItems}
            val={0}
            headerText="Document Details"
            child={<DocumentDetails document={document} documentLoading={documentLoading} docError={docError} />}
          />
        }
        <AccoItem
          openItems={openItems}
          val={1}
          headerText="Document History"
          child={
            openItems.includes(1) && documentHistoryLoaded ? (
              <DocumentHistory versions={versions} document={document} versionLoading={versionLoading} />
            ) : null
          }
        />
      </Accordion>
    </div>
  );
}

const AccoItem = ({ openItems, val, headerText, child }) => {
  const isItemOpen = openItems.includes(val);
  return (
    <AccordionItem style={{ border: "solid #E8ECF4", borderWidth: "1px 0px", fontFamily: "Poppins" }} value={val}>
      <AccordionHeader
        style={{
          height: isItemOpen ? "auto" : "25px",
          padding: "8px 10px",
          display: "flex",
          alignItems: "center",
        }}
        expandIcon={isItemOpen ? <Subtract20Filled style={{ fontSize: "12px" }} /> : <Add20Filled />}
        expandIconPosition="end"
        size="small"
      >
        <div style={AccordianItemStyles}>{headerText}</div>
      </AccordionHeader>
      <AccordionPanel style={{ padding: "1vh 2vh 2vh", gap: "12px" }}>{child}</AccordionPanel>
    </AccordionItem>
  );
};

const DocumentDetailsText = ({ heading, text }) => {
  return (
    <div style={{ marginTop: "4%" }}>
      <Text
        style={{ color: "#51596C", fontWeight: 500, fontSize: "12px", lineHeight: "16px", fontFamily: "Poppins" }}
        block
        nowrap
      >
        {`${heading} :`}
      </Text>
      <Text
        style={{ color: "#1F2430", fontWeight: 600, fontSize: "12px", fontFamily: "Poppins", lineHeight: "16px" }}
        block
        nowrap
      >
        {text}
      </Text>
    </div>
  );
};

function getIcon(fileType, isRedlined, fileFormat) {
  if (fileFormat !== "pdf") {
    if (fileType == "sent") {
      return (
        <img
          src={require("../../../assets/airplane.png")}
          style={{ width: "18px", height: "22px", alignSelf: "flex-end" }}
        />
      );
    } else if (fileType == "received") {
      return (
        <img
          src={require("../../../assets/Envelop.png")}
          style={{ width: "18px", height: "22px", alignSelf: "flex-end" }}
        />
      );
    } else if (fileType === "draft" && isRedlined === true) {
      return (
        <img
          src={require("../../../assets/Doc.png")}
          style={{ width: "18px", height: "22px", alignSelf: "flex-end" }}
        />
      );
    } else {
      return fileFormat === "pdf" ? (
        <img
          src={require("../../../assets/pdf.png")}
          style={{ width: "19px", height: "22px", alignSelf: "flex-end", marginRight: fileType !== "draft" ? 4 : 0 }}
        />
      ) : (
        <img
          src={require("../../../assets/clean doc.png")}
          style={{ width: "18px", height: "22px", alignSelf: "flex-end" }}
        />
      );
    }
  }
}

const DocumentDetails = ({ document, documentLoading, docError }) => {
  const copiedPersons = [];
  const shared = document?.shareDetails?.replyAll;
  shared &&
    shared.forEach((sharedPerson) => {
      copiedPersons.push(sharedPerson.name);
    });

  const openDownloadDialog = () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const messageToShareDialog = JSON.stringify({
        access_token: await getToken(),
        documentId: document.id,
        url: context.value.url,
        documentName: document.rootDocumentName,
      });
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/Download.html`,
        {
          width: 45,
          height: 38,
          displayInIframe: true,
        },
        (result) => {
          var dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            var message = JSON.parse(arg.message);
            if (message.type === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (message.type === "close") {
              dialog.close();
            }
          });
        }
      );
    });
  };

  return documentLoading ? (
    <Stack className="laodingContainer">
      <Spinner />
    </Stack>
  ) : !docError && document ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0px 15px 15px 15px",
        width: "80%",
        marginLeft: "4%",
        marginTop: "2%",
        borderRadius: "4px",
        border: "1px solid #E8ECF4",
        backgroundColor: "#F3F5F9",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <div
          style={{
            width: "55%",
            height: "17%",
            borderRadius: "0px 0px 4px 4px",
            backgroundColor: "#007CFF",
            textAlign: "center",
          }}
        >
          <Text
            style={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "12px",
              color: "#FFFFFF",
            }}
          >
            Document Details
          </Text>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", width: "95%" }}>
        <div
          style={{
            width: "92%",
            height: "65%",
            gap: "12px",
            display: "flex",
            flexDirection: "column",
            marginTop: "4%",
          }}
        >
          <div
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "14px",
              color: "#1F2430",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              textOverflow: "ellipsis",
              WebkitLineClamp: 2,
              overflow: "hidden",
              minHeight: "14px",
            }}
            title={document?.rootDocumentName?.split(".docx")[0]}
          >
            {document?.rootDocumentName?.split(".docx")[0]}
          </div>
          <div style={{ display: "flex", flexDirection: "column", width: "85%", height: "32px" }}>
            <Text
              style={{ fontFamily: "Poppins", fontWeight: 500, fontSize: "12px", lineHeight: "16px", color: "#51596C" }}
            >
              Project:
            </Text>
            <Text
              style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "12px", lineHeight: "16px", color: "#18468F" }}
            >
              {document.projectName}
            </Text>
          </div>

          <DocumentDetailsText
            heading={"Last Saved On"}
            text={`${
              getFormattedDateTime(document?.lastUpdatedDate)[0] +
              " " +
              getFormattedDateTime(document?.lastUpdatedDate)[1]
            }`}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "15%",
            marginTop: "1%",
            justifyContent: "space-between",
          }}
        >
          {getIcon(document?.fileType, getIsRedlined(document), getFileType(document))}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignSelf: "flex-end",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <Text
              style={{
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "16px",
                color: "#1F2430F",
              }}
            >
              V{document.version}
            </Text>
            <img
              src={require("../../../assets/Download.png")}
              style={{ width: "17px", height: "16px", cursor: "pointer" }}
              onClick={() => {
                openDownloadDialog();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Text>Document Details not found.</Text>
  );
};

const DocumentHistory = ({ versions, document, versionLoading }) => {
  const [selectedForCompare, setSelectedForCompare] = useState([]);
  const [docToolTip, setDocToolTip] = useState(null);
  const [pdfToolTip, setPdfToolTip] = useState(null);

  const compare = () => {
    (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent"
      ? ensureDocumentSaved()
      : Promise.resolve(true)
    ).then((saved) => {
      if (!saved) return;
      Office.context.document.getFilePropertiesAsync(async (context) => {
        const messageToShareDialog = JSON.stringify({
          url: context.value.url,
          access_token: await getToken(),
          id: JSON.parse(sessionStorage.getItem("document")).id,
          base: selectedForCompare[0].id,
          revised: selectedForCompare[1].id,
          projectId: sessionStorage.getItem("projectId"),
          rootDocumentId: JSON.parse(sessionStorage.getItem("document")).rootDocumentId,
        });
        Office.context.ui.displayDialogAsync(
          `${process.env.BASE_URL}/Compare.html`,
          {
            width: 55,
            height: 75,
            displayInIframe: true,
          },
          (result) => {
            var dialog = result.value;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
              var message = JSON.parse(arg.message);
              if (message.type === "IAmReady") {
                dialog.messageChild(messageToShareDialog);
              }
              if (message.type === "close") {
                dialog.close();
                setSelectedForCompare([]);
                setIsChecked(false);
              }
              if (message.type === "open") {
                dialog.close();
                launchDocument(message.data);
              }
            });
          }
        );
      });
    });
  };
  useEffect(() => {
    if (selectedForCompare.length == 2) {
      setSelectedForCompare((prevSelected) => prevSelected.sort((a, b) => a.date - b.date));
      compare();
    }
  }, [selectedForCompare]);

  return versionLoading ? (
    <Stack>
      <Spinner />
    </Stack>
  ) : versions ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        width: "100%",
        backgroundColor: "",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          maxHeight: "53vh",
          overflowY: "scroll",
          backgroundColor: " ",
          width: "100%",
        }}
      >
        {versions &&
          versions.map((version, index) => {
            let fromName = "";
            let toName = [];
            if (version?.fileType !== "draft") {
              version?.shareDetails?.replyAll.forEach((user) => toName.push(user.firstName + " " + user.lastName));
              fromName = version?.shareDetails?.reply.firstName + " " + version?.shareDetails?.reply.lastName;
            }
            return (
              <div key={getDriveItemId(version)}>
                <Document
                  version={version?.version}
                  folderName={version?.projectName}
                  fileType={version?.fileType}
                  isRedlined={getIsRedlined(version)}
                  sharedBy={version?.shareDetails?.reply}
                  sharedTo={version?.shareDetails?.replyAll}
                  pdfURl={version?.attachment?.documentLink}
                  fromName={fromName}
                  toName={toName}
                  lastUpdatedDate={version?.lastUpdatedDate}
                  isCurrent={version?.id === document?.id}
                  documentUrl={getDocumentLink(version)}
                  documentId={version?.id}
                  selectedForCompare={selectedForCompare}
                  setSelectedForCompare={setSelectedForCompare}
                  emailNotes={version?.shareDetails?.emailNotes}
                  docToolTip={docToolTip}
                  setDocToolTip={setDocToolTip}
                  pdfToolTip={pdfToolTip}
                  setPdfToolTip={setPdfToolTip}
                  index={index}
                  receivedList={version?.shareDetails?.replyAll?.filter(
                    (user) => user?.userId !== version?.shareDetails?.reply?.userId
                  )}
                  subject={version?.shareDetails?.subject}
                  isPdf={version?.metadata.fileType === "pdf"}
                  attachmentData={version.attachment}
                />
              </div>
            );
          })}
      </div>
    </div>
  ) : (
    <Text>Document History not found.</Text>
  );
};
const documentGridStyle = {
  height: "max-content",
  width: "85%",
  display: "grid",
  rowGap: "6px",
  gridTemplateColumns: "80% 20%",
  gridTemplateAreas: `
      'version icon'
      'mydraft pdfIcon'
      'l1 access'
      'recieved compare'
    `,
  borderRadius: "4px",
  margin: "0 0 0 4%",
  backgroundColor: "#F3F5F9",
  paddingLeft: "4%",
  position: "relative",
};

export const Document = ({
  version,
  fileType,
  isRedlined,
  fromName,
  toName,
  lastUpdatedDate,
  isCurrent,
  documentUrl,
  documentId,
  selectedForCompare,
  setSelectedForCompare,
  folderName,
  emailNotes,
  sharedBy,
  sharedTo,
  pdfURl,
  ischecked,
  isdisabled,
  docToolTip,
  setDocToolTip,
  pdfToolTip,
  setPdfToolTip,
  index,
  receivedList,
  subject,
  isPdf,
  attachmentData,
}) => {
  const RecipientHoverCard = ({ recipients }) => {
    const plainCardProps = {
      onRenderPlainCard: () => (
        <div style={{ backgroundColor: "white", padding: "5px" }}>
          {recipients.map((recipient, index) => (
            <Text
              style={{ color: "#1F2430", fontWeight: 400, fontSize: "10px", fontFamily: "Poppins" }}
              block
              nowrap
              key={recipient.userId}
            >
              {recipient.firstName} {recipient.lastName}
            </Text>
          ))}
        </div>
      ),
    };

    return (
      <HoverCard type={HoverCardType.plain} plainCardProps={plainCardProps}>
        <div
          style={{
            fontSize: "1px",
            borderRadius: "1rem",
            minWidth: "1px",
            maxWidth: "fit-content",
            color: "blue",
            cursor: "pointer",
          }}
        >
          <Text style={{ fontWeight: 400, fontSize: "12px", fontFamily: "Poppins", color: "#18468F" }} block nowrap>
            {" "}
            ,&nbsp;+{recipients.length} {recipients.length === 1 ? "other" : "others"}
          </Text>
        </div>
      </HoverCard>
    );
  };

  const renderPerson = (recipients, fileType) => {
    let primaryName = "";
    let hoverCardRecipients = [];
    let showHoverCard = false;

    if (fileType === "received") {
      primaryName = "Me";

      if (recipients && recipients.length > 0) {
        showHoverCard = true;
        hoverCardRecipients = recipients;
      }
    } else if (recipients && recipients.length > 0) {
      primaryName = `${recipients[0].firstName} ${recipients[0].lastName}`;

      if (recipients.length > 1) {
        showHoverCard = true;
        hoverCardRecipients = recipients.slice(1);
      }
    } else {
      return null;
    }

    return (
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <Text className="boldSmallText" block nowrap>
          {primaryName}
        </Text>
        {showHoverCard && <RecipientHoverCard recipients={hoverCardRecipients} />}
      </div>
    );
  };

  const date = new Date(lastUpdatedDate);

  const [isChecked, setIsChecked] = useState(ischecked ? true : false);
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    if (e.target.checked) {
      setSelectedForCompare((prevSelected) => [...prevSelected, { id: documentId, date: date }]);
    } else setSelectedForCompare((prevSelected) => prevSelected.filter((item) => item.id !== documentId));
  };
  useEffect(() => {
    if (selectedForCompare && selectedForCompare?.length === 0) setIsChecked(false);
  }, [selectedForCompare]);
  return (
    <div
      style={{
        ...documentGridStyle,
        border: `1px solid ${isCurrent ? "#007CFF" : "#E8ECF4"}`,
        marginTop: isCurrent ? "14px" : "",
      }}
    >
      {isCurrent && (
        <Stack style={{ position: "absolute", justifyContent: "space-between", width: "100%" }}>
          <Stack style={{ position: "absolute", left: 10, top: -15, color: "white" }}>
            <img src={require("../../../assets/rectangle.png")} />
            <Text
              style={{ position: "absolute", top: 2, left: 7, color: "white", fontFamily: "Poppins", fontSize: "8px" }}
            >
              Current Document
            </Text>
          </Stack>
        </Stack>
      )}
      <div
        style={{
          color: "#1F2430",
          fontSize: "4vw",
          fontWeight: "600",
          gridArea: "version",
          fontFamily: "Poppins",
          marginTop: "4%",
        }}
      >
        V{version}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gridArea: "icon",
          paddingLeft: "8px",
          paddingTop: "5%",
        }}
      >
        {fileType === "draft" ? (
          <img
            style={{ marginTop: "5px" }}
            onClick={() => (pdfURl && isPdf ? window.open(pdfURl) : null)}
            src={
              isPdf
                ? require("../../../assets/pdf.png")
                : isRedlined === true
                ? require("../../../assets/Doc.png")
                : require("../../../assets/clean doc.png")
            }
            alt="File Icon"
          />
        ) : (
          <div style={{ cursor: "pointer" }}>
            <FileIconHoverCard
              recipientsNames={toName}
              notes={emailNotes ?? ""}
              fileType={fileType}
              sharedBy={sharedBy}
              sharedTo={sharedTo}
              projectName={folderName}
              fromName={fromName}
              subject={subject}
              receivedList={receivedList}
              url={documentUrl}
              isPdf={isPdf}
            />
          </div>
        )}
      </div>
      {attachmentData?.fileType === "pdf" && (
        <PdfAttachmentViewer index={index} pdfToolTip={pdfToolTip} setPdfToolTip={setPdfToolTip} pdfURl={pdfURl} />
      )}
      {fileType === "draft" ? (
        <>
          <div
            style={{
              gridArea: "mydraft",
              fontFamily: "Poppins",
              fontSize: "10px",
              fontWeight: 600,
              color: "#1F2430",
              lineHeight: "14px",
              height: "34px",
            }}
          >
            My Draft
          </div>
          <div
            style={{
              gridArea: "recieved",
              marginBottom: "6%",
              display: "flex",
              flexDirection: "column",
              gap: "3px",
            }}
          >
            <Text className="greySmallText">Last&nbsp;Saved&nbsp;On</Text>
            <Text className="boldSmallText">
              {`${getFormattedDateTime(lastUpdatedDate)[0] + " " + getFormattedDateTime(lastUpdatedDate)[1]}`}
            </Text>
          </div>
        </>
      ) : (
        <>
          <div style={{ gridArea: "mydraft", display: "flex", flexDirection: "column", gap: "2px" }}>
            <div style={{ display: "flex" }}>
              <Text className="greySmallText">From:&nbsp; </Text>
              <Text className="boldSmallText">{fileType === "sent" ? "Me" : fromName}</Text>
            </div>
            <div style={{ display: "flex" }}>
              <Text className="greySmallText">To:&nbsp;</Text>
              <Text className="boldSmallText">
                {fileType === "received" ? renderPerson(receivedList, fileType) : renderPerson(sharedTo, fileType)}
              </Text>
            </div>
          </div>
          <div
            style={{
              gridArea: "recieved",
              display: "flex",
              flexDirection: "column",
              gap: "3px",
              marginBottom: "4%",
            }}
          >
            {fileType === "sent" ? (
              <>
                <Text className="greySmallText">Sent&nbsp;On:</Text>
                <Text className="boldSmallText">
                  {`${getFormattedDateTime(lastUpdatedDate)[0] + " " + getFormattedDateTime(lastUpdatedDate)[1]}`}
                </Text>
              </>
            ) : (
              <>
                <Text className="greySmallText">Received&nbsp;On:</Text>
                <Text className="boldSmallText">
                  {`${getFormattedDateTime(lastUpdatedDate)[0] + " " + getFormattedDateTime(lastUpdatedDate)[1]}`}
                </Text>
              </>
            )}
          </div>
        </>
      )}

      <div
        style={{
          gridArea: "compare",
          display: "flex",
          flexDirection: "column",
          padding: "15px 30px 10px 0px",
          fontFamily: "Poppins",
        }}
      >
        {!isPdf && (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "2px" }}>
            <Text style={{ color: "#7C8497", fontSize: "9px", fontFamily: "Poppins" }}>Compare</Text>
            <Checkbox
              label=""
              styles={{
                checkbox: {
                  height: "11px",
                  width: "11px",
                  fontSize: "8px",
                  color: "#7C8497",
                },
                label: {
                  fontSize: "8px",
                  justifyContent: "center",
                },

                root: {
                  fontSize: "8px",
                },
              }}
              checked={isChecked}
              onChange={handleCheckboxChange}
              disabled={isdisabled ? true : false}
            />
          </div>
        )}
      </div>
      {!isCurrent && (
        <div style={{ gridArea: "access", display: "flex", justifyContent: "flex-end", paddingRight: "26%" }}>
          {(fileType && fileType === "sent") || isPdf ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                position: "relative",
                top: isPdf ? 38 : undefined,
              }}
            >
              <ViewDoc display={index === docToolTip} />
              <div
                id="lock"
                style={{ cursor: "pointer", paddingLeft: "4px" }}
                onClick={() => {
                  launchDocument(documentUrl);
                }}
                onMouseEnter={() => {
                  setDocToolTip(index);
                }}
                onMouseLeave={() => {
                  setDocToolTip(null);
                }}
              >
                <LockIcon />
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", position: "relative" }}>
              <EditDoc display={index === docToolTip} />
              <div
                id="edit"
                style={{ cursor: "pointer", right: "-5px", paddingLeft: "4px" }}
                onClick={() => {
                  console.log("redirection initiated");
                  launchDocument(documentUrl);
                }}
                onMouseEnter={() => {
                  setDocToolTip(index);
                }}
                onMouseLeave={() => {
                  setDocToolTip(null);
                }}
              >
                <EditIcon />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
